import React from "react";
import { useSchema } from "../ContractContext";
import { display, enumDisplay } from "./display";
import TimeSince from "./TimeSince";
import { ContractUpdate } from "./ContractUpdate";

export function ContractUpdatesList({
  updates,
}: {
  updates: ContractUpdate[];
}) {
  const schema = useSchema();
  return (
    <div className="ContractUpdates">
      <div className="Description">
        <p>Her kan du se endringer din motpart har gjort i kontrakten</p>
      </div>
      {updates
        .map(({ date, ...rest }) => ({ date: new Date(date), ...rest }))
        .reduce((winners, { date, section, field, value, ...rest }) => {
          let match = winners.filter(
            (g) => g.section === section && g.field === field
          )[0];

          if (!match) {
            match = { section, field, date, value, ...rest };

            return [...winners, match];
          }

          if (match.date < date) {
            match.date = date;
            match.value = value;
          }

          return winners;
        }, [] as (Omit<ContractUpdate, "date"> & { date: Date })[])
        .map(({ date, section, field, value, isEnumValue }) => (
          <div key={`${section}-${field}-${date}`} className="Item">
            <strong>{schema.getFieldLabel(section, field)}</strong> endret til{" "}
            <strong>
              {isEnumValue
                ? enumDisplay(schema, section, field, value)
                : display(value)}
            </strong>
            <small>
              <TimeSince date={date} />
            </small>
          </div>
        ))}
    </div>
  );
}
